import React, {useState} from 'react';
import './IndexNews.css';
import ChangeLink from "../../../Elements/ChangeLink/ChangeLink";

function createDangerHTML(info) {
    return {__html : info}
}

function IndexNews(props) {
    function TextSource(info) {try {return <>{JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] ? JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] : '*' + info.children}</>} catch (err) {return <>*{info.children}</>}}

    const [NewsStatus, setNewsStatus] = useState('IndexNewsFirst');

    function SetNewActive(NewStatus) {setNewsStatus(NewStatus);}

        let lang = props.lang;
        const IndexProvidersCircleMap =  props.ArrayNews.map( function(element, index) {
            return(
            <div key={index} className="IndexNewsBodyElement">
                <div className="IndexNewsBodyElementDate">{element[1]}-{element[2]}-{element[3]}</div>
                <ChangeLink lang={props.lang} to='/news'><div className="IndexNewsElementText" dangerouslySetInnerHTML= {createDangerHTML(element[0])}/></ChangeLink>
            </div>

            )
        });
        return (
        <div className="IndexNews">
            <div className="IndexNewsTop"><TextSource ArrIndex= 'index0070'>News</TextSource></div>
            <div className="IndexNewsBody">
                {IndexProvidersCircleMap}
                {/*<div className="IndexNewsBodyElement">*/}
                {/*    <div className="IndexNewsBodyElementDate">26 June 2020</div>*/}
                {/*    <div className="IndexNewsBodyElementText">*/}
                {/*        Changes in the schedule of trading sessions on July 3, 2020 in connection with the celebration of Independence Day in the United States*/}
                {/*    </div>*/}
                {/*</div>*/}
                {/*<div className="IndexNewsBodyElement">*/}
                {/*    <div className="IndexNewsBodyElementDate">29 May 2020</div>*/}
                {/*    <div className="IndexNewsBodyElementText">Schedule changes for Holy Spirit Day</div>*/}
                {/*</div>*/}

            </div>
        </div>

        )}
export default IndexNews


